module.exports = __webpack_public_path__ + "static/img/5021_phase_function_Paper_Points.3ed868a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5021_phase_function_Paper_Points.png
// module id = op1k
// module chunks = 0